module.exports = __webpack_public_path__ + "img/58200.a394cd65.jpg";